import { render } from "./IziCol.vue?vue&type=template&id=285af65a"
import script from "./IziCol.vue?vue&type=script&lang=ts"
export * from "./IziCol.vue?vue&type=script&lang=ts"
script.render = render

export default script